module.exports = __webpack_public_path__ + "img/小程序 (1).c5902edf.png";